"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptimizacionResultado = void 0;
class OptimizacionResultado {
    constructor() {
        this.codigo = "";
    }
    OptimizacionResultado() {
        this.codigo = "";
    }
}
exports.OptimizacionResultado = OptimizacionResultado;
